import { faSquareExclamation } from "@jewlr/pro-light-svg-icons/faSquareExclamation"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"

const ErrorGroup = ({ active = true, pref }) => {
  const choices = useSelector((state) => state.choices)
  const wizardData = useSelector((state) => state.wizard?.data)
  const [visibleErrors, setVisibleErrors] = useState([])

  const errors = []
  const choiceKey = pref === "diamond" ? "s1" : pref

  const addError = (key) => {
    const choice = choices?.[key]
    if (!choice?.error) return

    errors.push({
      key,
      message:
        typeof choice.error === "string"
          ? choice.error
          : wizardData?.[key]?.missing_msg || "Please complete this option.",
      revision: choice.errorRevision || 0,
    })
  }

  addError(choiceKey)
  if (pref === "diamond") {
    ;["d_carat", "d_cut", "d_clarity", "d_shape", "d_color"].forEach(addError)
  }

  if (wizardData?.[pref]?.engravings) {
    wizardData[pref].engravings.forEach((engraving) => {
      addError(engraving.pref)
    })
  }

  // Only this group's errors trigger an update. A new revision also repeats
  // identical warnings without reacting to changes in unrelated options.
  const errorSignature = JSON.stringify(errors)
  useEffect(() => {
    setVisibleErrors([])
    const nextErrors = JSON.parse(errorSignature)
    if (!active || !nextErrors.length) return

    // Expand animates for 300ms; populate the live region after it is visible.
    const timer = setTimeout(() => setVisibleErrors(nextErrors), 350)
    return () => clearTimeout(timer)
  }, [active, errorSignature])

  return (
    <div aria-atomic="true" role="alert">
      {visibleErrors.length > 0 && (
        <div className="text-error text-14 mb-16 flex items-center gap-6 font-medium italic">
          <FontAwesomeIcon className="text-16" icon={faSquareExclamation} />
          <div>
            {visibleErrors.map((error) => (
              <p id={`wizard-error-${error.key}`} key={error.key}>
                {error.message}
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

ErrorGroup.propTypes = {
  active: PropTypes.bool,
  pref: PropTypes.string.isRequired,
}

export default ErrorGroup
